import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';

import '../contracts/Orders_AtributosLaudoResponse';
import '../contracts/Orders_SalvarAtributosLaudoInput';
import '../contracts/Orders_SalvarAtributosLaudoResponse';
import type { Orders_SalvarAtributosLaudoInput } from '../contracts/Orders_SalvarAtributosLaudoInput';
/**
 * Composable for SO Report Attribute Values operations.
 * Handles fetching and saving laudo attribute definitions and values
 * for both entry and exit reports.
 */
export function useSOReportAttributeValues() {
  const isLoading = ref(false);
  const error = ref(null);
  const basePath = '/index.php/so/orders';

  const fetchLaudoAttributes = async (orderItemId: any, reportType = 'entry') => {
    log('useSOReportAttributeValues', 'fetchLaudoAttributes', 'Fetching report attributes and values', { orderItemId, reportType });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/atributos_laudo/${orderItemId}/${reportType}`, { responseContract: 'Orders_AtributosLaudoResponse' });
      if (response.success) {
        return {
          definitions: response.dados?.definitions || [],
          values: response.dados?.values || []
        };
      }
      throw new Error(response.error || 'Erro ao buscar atributos de laudo');
    } catch (err) {
      logError('useSOReportAttributeValues', 'fetchLaudoAttributes', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const saveLaudoAttributeValues = async (orderItemId: any, values: any, reportType = 'entry') => {
    const payload: Orders_SalvarAtributosLaudoInput = { values };
    log('useSOReportAttributeValues', 'saveLaudoAttributeValues', 'Saving report attribute values', { orderItemId, reportType, payload });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.post(`${basePath}/salvar_atributos_laudo/${orderItemId}/${reportType}`, payload, { inputContract: 'Orders_SalvarAtributosLaudoInput', responseContract: 'Orders_SalvarAtributosLaudoResponse' });
      if (response.success) {
        return response;
      }
      throw new Error(response.error || 'Erro ao salvar atributos de laudo');
    } catch (err) {
      logError('useSOReportAttributeValues', 'saveLaudoAttributeValues', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    fetchLaudoAttributes,
    saveLaudoAttributeValues
  };
}
